import React, { Component } from 'react';
import { connect } from 'react-redux';

import {
  addComparisonPlan,
  removeComparisonPlan,
  setQuotationParams,
  openModalQuotationDateWarning,
  openModalQuotationDateYear,
  openModalWithoutTracker,
  closeModalFilterCategory,
  setInfosModalProspect,
  trackerModalValidatorHandlerBlur,
  validateTrackerModalRedirect,
  applyFilterCategories,
  clearFilterCategories,
  searchEcommerceSettings,
  searchProviderSettings,
} from '../../actions/searchActions';

import { triggerRdStationVerify } from '../../utils/rdstation';
import { getAuthCookie } from '../../utils';

import SearchBar from '../../components/search/searchbar/SearchBar';
import SearchBarMobile from '../../components/search/searchbar/SearchBarMobile';

import PlansTable from '../../components/search/plans_table/PlansTable';
import ComparisonBar from '../../components/search/comparison_bar/ComparisonBar';

import ModalFilterCategory from '../../components/search/modal_filter_category/ModalFilterCategory';
import ModalQuotationDateWarning from '../../components/common/modal_quotation_date_warning/ModalQuotationDateWarning';
import ModalQuotationDateYear from '../../components/common/modal_quotation_date_year/ModalQuotationDateYear';
import ModalWithoutTracker from '../../components/common/modal_without_tracker/ModalWithoutTracker';

import './Search.css';
import { changeTitle, cleanDate, isSameDaySearch, quotationDateYear, verifyOriginSearchUrl } from '../../utils';
import { runGoogleAdWordsConversionSearch } from '../../SeoFunctions';
import { fetchEcommerceConfigService, fetchProvidersService } from '../../apiCalls';

import store from '../../store';

class Search extends Component {
  constructor(props) {
    super(props);

    changeTitle('search', props.match.params.destination);

    this.handleApplyFilterCategory = this.handleApplyFilterCategory.bind(this);
    this.handleClearAllFilterCategory = this.handleClearAllFilterCategory.bind(this);

    this.state = {
      destinations: this.props.destinations || [],
    };
  }

  componentDidMount() {
    runGoogleAdWordsConversionSearch();

    this.sendLoginTriggerToRDStation();

    fetchEcommerceConfigService().then((response) => {
      store.dispatch(searchEcommerceSettings(response.data));
    });

    fetchProvidersService().then((response) => {
      store.dispatch(searchProviderSettings(response.providers));
    });

    if (isSameDaySearch(this.props.match.params.begin_date) && !this.props.userDetails.operator_permissions) {
      this.props.openModalQuotationDateWarning();
    }

    if (quotationDateYear(this.props.match.params.begin_date, this.props.match.params.end_date)) {
      this.props.openModalQuotationDateYear();
    }

    if (verifyOriginSearchUrl(this.props.location.search)) {
      this.props.openModalWithoutTracker();
    }
  }

  sendLoginTriggerToRDStation(props = this.props) {
    const authCookie = getAuthCookie();
    if (!authCookie) {
      return;
    }

    let userName = '';
    let userEmail = '';

    try {
      const authData = JSON.parse(authCookie || '{}');
      if (authData.isAuthenticated) {
        userName = authData.username || '';
        userEmail = authData.email || '';
      }
    } catch (e) {
      return;
    }

    const destination = props.match.params.destination || '';

    const loginTriggerEventData = {
      name: userName,
      email: userEmail,
      searchParams: `${destination}/${props.match.params.begin_date}/${props.match.params.end_date}`,
      departureDate: props.match.params.begin_date,
      returnDate: props.match.params.end_date,
    };

    triggerRdStationVerify(loginTriggerEventData);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.destinations !== this.props.destinations) {
      this.setState({ destinations: this.props.destinations });
    }

    // mover lógica do antigo componentWillReceiveProps
    if (prevProps.location !== this.props.location) {
      this.props.setQuotationParams({
        destination: this.props.match.params.destination,
        begin_date: cleanDate(this.props.match.params.begin_date),
        end_date: cleanDate(this.props.match.params.end_date),
        context: 'search',
        product_code: '',
        benefits: [],
        queryParams: this.props.location.search,
      });
    }

    // reenviar trigger de login quando parâmetros relevantes mudarem
    if (
      prevProps.location !== this.props.location ||
      prevProps.match.params.destination !== this.props.match.params.destination ||
      prevProps.match.params.begin_date !== this.props.match.params.begin_date ||
      prevProps.match.params.end_date !== this.props.match.params.end_date
    ) {
      this.sendLoginTriggerToRDStation();
    }
  }

  handleApplyFilterCategory() {
    const { filterCategory, filterProvider } = this.props;

    const categoryList = [];
    const providersList = [];

    filterCategory.forEach((category) => {
      category.Categories.forEach((option) => {
        if (option.selected === true) categoryList.push(option.ID);
      });
    });

    filterProvider.forEach((provider) => {
      if (provider.selected === true) providersList.push(provider.slug);
    });

    let newUrlParams = '';
    let searchParams = window.location.search.replace('?', '').split('&');

    searchParams = searchParams.filter(
      (oldCategory) => !oldCategory.includes('category=') && !oldCategory.includes('provider=')
    );

    searchParams.forEach((param, index) => {
      if (param === '') return;
      newUrlParams += index > 0 ? `&${param}` : `?${param}`;
    });

    let location = newUrlParams;

    if (categoryList.length > 0) {
      if (newUrlParams !== '') {
        location += `&category=${categoryList}`;
      } else {
        location += `?category=${categoryList}`;
      }
    }
    if (providersList.length > 0) {
      if (newUrlParams !== '' || location.length > 1) {
        location += `&provider=${providersList}`;
      } else {
        location += `?provider=${providersList}`;
      }
    }

    window.history.replaceState(null, null, location);

    try {
      const { getFilterSearchUrl } = require('../../utils');
      const { getCategory } = require('../../apiCalls');
      const params = getFilterSearchUrl(location || window.location.search);
      getCategory(params);
    } catch (e) {}

    this.props.applyFilterCategories();

    const filtersWrapper = document.getElementById('filters-wrapper');
    if (filtersWrapper) {
      filtersWrapper.scrollIntoView({ behavior: 'smooth' });
    }
  }

  handleClearAllFilterCategory() {
    let newUrlParams = '';
    let location = '';
    let searchParams = window.location.search.replace('?', '').split('&');

    searchParams = searchParams.filter(
      (oldCategory) => !oldCategory.includes('category=') && !oldCategory.includes('provider=')
    );

    searchParams.forEach((param, index) => {
      if (param === '') return;
      newUrlParams += index > 0 ? `&${param}` : `?${param}`;
    });

    if (newUrlParams !== '') {
      location = newUrlParams;
    } else {
      location = window.location.pathname;
    }

    this.props.clearFilterCategories();
    window.history.replaceState(null, null, location);
  }

  render() {
    if (!this.state.destinations) return null;

    return (
      <main>
        <div className="comp_main clearfixs">
          <div
            className={`listagem-planos${
              this.props.comparisonPlans && this.props.comparisonPlans.length ? ' with-comparision' : ''
            }`}
          >
            <section className="resultado-filtro">
              <div className="component search-frame">
                <div className="listagem-planos">
                  {this.props.mobile ? (
                    <SearchBarMobile searchPlan={this.searchPlan} destinations={this.props.destinations} />
                  ) : (
                    <SearchBar destinations={this.props.destinations} />
                  )}

                  {this.props.isModalWithoutTrackerActive ? (
                    <div />
                  ) : (
                    <PlansTable
                      settings={this.props.ecommerce_settings}
                      providers={this.props.providers}
                      destinations={this.props.destinations}
                    />
                  )}
                </div>
              </div>
            </section>

            {this.props.comparisonPlans && this.props.comparisonPlans.length > 0 && (
              <ComparisonBar destinations={this.props.destinations} />
            )}

            <ModalQuotationDateWarning />
            <ModalQuotationDateYear />
            <ModalWithoutTracker
              isModalWithoutTrackerActive={this.props.isModalWithoutTrackerActive}
              prospect={this.props.modalProspect}
              modalProspectAvaliable={this.props.modalProspectAvaliable}
              setInfosModalProspect={this.props.setInfosModalProspect}
              trackerModalValidatorHandlerBlur={this.props.trackerModalValidatorHandlerBlur}
              coupon={this.props.coupon}
              redirectToTracker={(cupom) => {
                this.props.validateTrackerModalRedirect(
                  this.props.match.params.destination,
                  this.props.match.params.begin_date,
                  this.props.match.params.end_date,
                  cupom
                );
              }}
            />
            <ModalFilterCategory
              activeModal={this.props.isModalFilterCategoryActive}
              closeModal={this.props.closeModalFilterCategory}
              category={this.props.filterCategory}
              providers={this.props.filterProvider}
              applyFilter={this.handleApplyFilterCategory}
              clearFilter={this.handleClearAllFilterCategory}
            />
          </div>
        </div>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  comparisonPlans: state.search.comparisonPlans,
  userDetails: state.search.userDetails,
  coupon: state.purchase.coupon,
  mobile: state.mobile.mobileActive,
  isModalWithoutTrackerActive: state.search.isModalWithoutTrackerActive,
  isModalFilterCategoryActive: state.search.isModalFilterCategoryActive,
  modalProspect: state.search.modalProspect,
  modalProspectAvaliable: state.search.modalProspectAvaliable,
  filterCategory: state.search.filterCategory,
  filterProvider: state.search.filterProvider,
  ecommerce_settings: state.search.ecommerce_settings,
  providers: state.global.providers,
  destinations: state.global.destinations,
});

export default connect(mapStateToProps, {
  searchEcommerceSettings,
  searchProviderSettings,
  addComparisonPlan,
  removeComparisonPlan,
  setQuotationParams,
  openModalQuotationDateWarning,
  openModalQuotationDateYear,
  openModalWithoutTracker,
  closeModalFilterCategory,
  setInfosModalProspect,
  trackerModalValidatorHandlerBlur,
  validateTrackerModalRedirect,
  applyFilterCategories,
  clearFilterCategories,
})(Search);



// WEBPACK FOOTER //
// ./src/views/search/Search.jsx